import * as constants from "./constants";

import Home from "./components/Home";
import Login from "./components/user/Login";
import Register from "./components/user/Register";

import Categories from "./components/categories/Categories";
import CategoriesList from "./components/categories/CategoriesList";
import CategoryDetail from "./components/categories/CategoryDetail";
import CategoryEdit from "./components/categories/CategoryEdit";
import NewCategory from "./components/categories/NewCategory";

import Food from "./components/food/Food";
import FoodList from "./components/food/FoodList";
import FoodEdit from "./components/food/FoodEdit";
import NewFood from "./components/food/NewFood";

export default [
  {
    path: "",
    component: Home,
    name: constants.ROUTE_HOME
  },
  {
    path: "/login", // TODO: add route blocking based on logged user
    component: Login,
    name: constants.ROUTE_LOGIN
  },
  {
    path: "/register",
    component: Register,
    name: constants.ROUTE_REGISTER
  },
  {
    path: "/food",
    component: Food,
    children: [
      {
        path: "",
        component: FoodList,
        name: constants.ROUTE_FOOD,
        props: true
      },
      {
        path: "new",
        component: NewFood,
        name: constants.ROUTE_NEW_FOOD,
        props: true
      },
      {
        path: ":id/edit",
        component: FoodEdit,
        name: constants.ROUTE_FOOD_EDIT
      }
    ]
  },
  {
    path: "/categories",
    component: Categories,
    children: [
      {
        path: "",
        component: CategoriesList,
        name: constants.ROUTE_CATEGORIES,
        props: true
      },
      {
        path: "new",
        component: NewCategory,
        name: constants.ROUTE_NEW_CATEGORY
      },
      {
        path: ":id",
        component: CategoryDetail,
        name: constants.ROUTE_CATEGORY_DETAIL
      },
      {
        path: ":id/edit",
        component: CategoryEdit,
        name: constants.ROUTE_CATEGORY_EDIT
      }
    ]
  }
];
